import { CheckCircle2, ChevronRight, Handshake, Loader2 } from 'lucide-react'
import { Link } from 'react-router-dom'
import { format, parseISO } from 'date-fns'
import HomeFeedItem from '@/components/dashboard/HomeFeedItem'
import { useHomeFeedItems } from '@/hooks/useHomeFeedItems'

const HomeFeed = () => {
  const { items, nextUp, isLoading } = useHomeFeedItems()

  if (isLoading && items.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-gray-500">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <>
        <div className="bg-card border border-[#C0FD72]/15 rounded-2xl p-5 flex items-start gap-3 shadow-[0_1px_2px_rgba(30,41,59,0.04)]">
          <div className="w-10 h-10 rounded-full bg-[#C0FD72]/15 flex items-center justify-center shrink-0">
            <CheckCircle2 className="h-5 w-5 text-[#4d7c0f]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-foreground">You're all caught up</p>
            {nextUp ? (
              <p className="text-sm text-gray-500 mt-1">
                Next up: <span className="text-gray-700">{nextUp.brandName}</span> content due{' '}
                {format(parseISO(nextUp.date), 'MMM d')}.
              </p>
            ) : (
              <p className="text-sm text-gray-500 mt-1">Nothing on the horizon right now.</p>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-2 mt-4">
          <Link
            to="/collaborations"
            className="group flex items-center gap-3 bg-card border border-foreground/10 hover:border-[#C0FD72]/30 hover:bg-foreground/[0.07] rounded-2xl px-4 py-3.5 transition-colors shadow-[0_1px_2px_rgba(30,41,59,0.04)]"
          >
            <div className="w-10 h-10 rounded-lg bg-[#C0FD72]/15 flex items-center justify-center shrink-0">
              <Handshake className="h-4 w-4 text-[#4d7c0f]" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground">
                Invite a brand to collaborate
              </p>
              <p className="text-xs text-gray-500 mt-0.5">
                Start a new campaign and bring a partner onto Athios
              </p>
            </div>
            <ChevronRight className="h-4 w-4 text-gray-500 group-hover:text-[#4d7c0f] shrink-0 transition-colors" />
          </Link>
        </div>
      </>
    )
  }

  return (
    <>
      <p className="text-xs font-semibold tracking-wider text-gray-500 uppercase mb-2.5">
        Needs your attention
      </p>
      <div className="flex flex-col gap-2">
        {items.map((item) => (
          <HomeFeedItem key={item.id} item={item} />
        ))}
      </div>
    </>
  )
}

export default HomeFeed
